/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable import/no-unresolved */
import React, { useRef } from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import slices from '../../state/slices/data';

export default function Header() {
  const annualRef = useRef();
  const weeklyRef = useRef();
  const data = useSelector((state) => state.data.data);
  const type = useSelector((state) => state.data.type);
  const sex = useSelector((state) => state.data.sex);
  const timeframe = useSelector((state) => state.data.timeframe);
  const incomeLevel = useSelector((state) => state.data.incomeLevel);
  const weeklySelectOptions = useSelector(
    (state) => state.data.weeklySelectOptions,
  );
  const annualSelectOptions = useSelector(
    (state) => state.data.annualSelectOptions,
  );
  const { setSex, setType, setIncome, setTimeframe } = slices.actions;
  const dispatch = useDispatch();

  const timeframeSelectOptions =
    timeframe === 'annual' ? annualSelectOptions : weeklySelectOptions;

  const sexSelectOptions = [
    { value: 'persons', label: 'Females and males' },
    { value: 'female', label: 'Females' },
    { value: 'male', label: 'Males' },
  ];

  const typeSelectOptions = [
    { value: 'all', label: 'Full-time and part-time ' },
    { value: 'full-time', label: 'Full-time' },
    { value: 'part-time', label: 'Part-time' },
  ];

  function handleSexChange(obj) {
    dispatch(setSex(obj.value));
  }

  function handleTypeChange(obj) {
    dispatch(setType(obj.value));
  }

  function handleIncomeChange(obj) {
    dispatch(setIncome(obj.value));
  }

  return (
    <header>
      <div className="headline">How does your income compare to others?</div>
      <p>Fill out the fields below to see how your income compares.</p>
      <h4>Select gender</h4>
      <Select
        onChange={handleSexChange}
        placeholder=""
        options={sexSelectOptions}
        className="selectItem"
        value={sexSelectOptions.find((e) => e.value === sex)}
      />
      <h4>Select employment type</h4>
      <Select
        onChange={handleTypeChange}
        placeholder=""
        options={typeSelectOptions}
        className="selectItem"
        value={typeSelectOptions.find((e) => e.value === type)}
      />
      <h4>Select annual income level (before tax)</h4>
      <Select
        placeholder=""
        options={timeframeSelectOptions}
        className="selectItem"
        value={timeframeSelectOptions.find((e) => e.value === incomeLevel)}
        onChange={handleIncomeChange}
      />
    </header>
  );
}
